import { bn } from "@opensea/utils";
import { useMemo } from "react";
import { buildPricingLookup, lookupPricingForItem } from "../QuoteReceipt/helpers";
export const usePriceValidation = ({
  itemsWithPricing,
  flow,
  itemQuotes
}) => {
  const initialPrices = useMemo(() => buildPricingLookup(itemsWithPricing), [itemsWithPricing]);
  const validationResult = useMemo(() => {
    if (itemQuotes.length === 0) {
      return {
        hasPriceChanged: false,
        changedItems: []
      };
    }
    const changedItems = [];
    itemQuotes.forEach(itemQuote => {
      const itemKey = `${itemQuote.item.chain}-${itemQuote.item.contractAddress}-${itemQuote.item.tokenId}`;
      const initialPrice = lookupPricingForItem({
        chain: {
          identifier: itemQuote.item.chain
        },
        contractAddress: itemQuote.item.contractAddress,
        tokenId: itemQuote.item.tokenId
      }, initialPrices);
      if (initialPrice) {
        const currentPrice = Number.parseFloat(itemQuote.pricePerItem.unit);
        const priceDifference = bn(currentPrice).minus(initialPrice.unit).toNumber();
        if (flow === "checkout" && priceDifference > 0) {
          changedItems.push({
            itemId: itemKey,
            initialPrice: initialPrice.unit,
            currentPrice,
            priceDifference
          });
        }
        if (flow === "accept-offer" && priceDifference < 0) {
          changedItems.push({
            itemId: itemKey,
            initialPrice: initialPrice.unit,
            currentPrice,
            priceDifference
          });
        }
      }
    });
    const result = {
      hasPriceChanged: changedItems.length > 0,
      changedItems
    };
    return result;
  }, [itemQuotes, initialPrices, flow]);
  return validationResult;
};